import { CreditCard } from '../../credit-card/models/model';

export const CREDIT_CARD_MIGRATION_IS_UNDER_WAY: string =
  'Karta nie została jeszcze zmigrowana przez operatora płatności. Możesz jednak dodać nową kartę i realizować' +
  ' nią płatności. Migracja powinna się zakończyć do 13.10.2022. Więcej informacji znajdziesz w linku u góry strony.';
export const CREDIT_CARD_EXPIRED: string =
  'Karta jest przeterminowana. Dodaj nową kartę, aby dalej móc wygodnie opłacać rachunki. ' +
  'Jeśli na przeterminowanej karcie są ustawione automatyczne płatności zmień kartę na nową.';

export const isCreditCardDisabled = (creditCard: CreditCard): boolean =>
  !creditCard.existsOnCurrentImojeService || new Date(creditCard.expirationDate).valueOf() < new Date().valueOf();
